export const GET_SETTINGS_STORE = 'providers/settings/SettingsStore/GET_SETTINGS_STORE';
export const UPDATE_SETTINGS_STORE = 'providers/settings/SettingsStore/UPDATE_SETTINGS_STORE';
export const GET_SETTING_CUSTOMIZE_PRINTS = 'providers/settings/SettingsStore/GET_SETTING_CUSTOMIZE_PRINTS';
